import React from "react";

interface VenmoIconProps {
  size?: number;
}

const VenmoIcon: React.FC<VenmoIconProps> = ({ size = 20 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size}>
    <path
      fill="#008CFF"
      d="M19.5 1c.9 1.5 1.3 3 1.3 5 0 5.4-4.6 12.4-8.3 17H4.8L2.2 2.5l7-.7 1.4 11.5c1.3-2.1 2.9-5.4 2.9-7.7 0-1.9-.3-3.1-.9-4.2L19.5 1z"
    />
  </svg>
);

export default VenmoIcon;
